module.exports = __webpack_public_path__ + "img/weal3.ac69113f.png";